import React from "react";

import { Logo } from "../Logo/Logo.component";
import imgButtonAppStore from "../../Assets/button-app-store.svg";
import imgButtonPlayStore from "../../Assets/button-play-store.svg";

import { Container, Divider } from "./Footer.styles";

export const Footer: React.FC = () => {
  const openLink = (url: string) => () => window.open(url, "_blank")?.focus();
  const linkAppStore = "https://apps.apple.com/br/app/rv-point/id1549869762";
  const linkPlayStore =
    "https://play.google.com/store/apps/details?id=br.com.aplic.app";

  return (
    <Container>
      <Logo type="RVDigital" />
      <Divider />
      <div>
        <h2>Baixe nosso app!</h2>
        <p>Disponível para todos os tipos de smartphone</p>
        <div>
          <img
            style={{ cursor: "pointer" }}
            onClick={openLink(linkPlayStore)}
            src={imgButtonPlayStore}
            alt="Botão Play Store"
          />
          <img
            style={{ cursor: "pointer" }}
            onClick={openLink(linkAppStore)}
            src={imgButtonAppStore}
            alt="Botão App Store"
          />
        </div>
      </div>
    </Container>
  );
};
